import React from "react";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet";
import { REACT_HELMET_PROPS } from "../config";

export const Route = createRootRoute({
  component: () => (
    <>
      <Helmet {...REACT_HELMET_PROPS} />
      <Outlet />
    </>
  ),
});
